import { render, staticRenderFns } from "./StatisticalReport.vue?vue&type=template&id=b564af32&scoped=true"
import script from "./StatisticalReport.vue?vue&type=script&lang=js"
export * from "./StatisticalReport.vue?vue&type=script&lang=js"
import style0 from "./StatisticalReport.vue?vue&type=style&index=0&id=b564af32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b564af32",
  null
  
)

export default component.exports